// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Servicos_DeleteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /config/servicos/delete
 *
 * Deletes a service by ID.
 */
import { registerContract } from './validate'

export interface Servicos_DeleteInput {
id: number
}

registerContract('Servicos_DeleteInput', {
  id: { type: 'number',  required: true },
})
